import "@fontsource/open-sans";
import '@fontsource/inter';
import AppRoutes from "../src/components/routes/route";
import './App.css';


function App() {
  return <AppRoutes />;
}

export default App;